import { Component, Vue } from 'vue-property-decorator'
import { getWorkOrderAnomaly, noticeAnomalyOrder, addOrderRecord, setWorkOrderStatus, submitterAnomalyReport } from '@/api'
import { TagsViewModule } from '@/store/modules/tags-view'
import urlBase from '@/utils/urlBase'

@Component({ name: 'approveDetailAnomaly' })
export default class ApproveDetailAnomaly extends Vue {
  private dialogVisible = false;
  private addDialogVisible = false; // 新增处理进度的dialog

  private addResult = false; // 处理情况
  private addProgress = ''; // 处理进度
  private addImgList: any = []; // 沟通截图
  // private uploadUrl = 'http://192.168.0.33:10069/upload/anomaly/notice'
  // TODO
  private uploadUrl = urlBase.eduBaseUrl + 'upload/anomaly/notice'
  private orderId: any = null
  private pageData = {};
  private reason = '';
  private loading = false
  private action: any = null;
  created () {
    this.orderId = this.$route.query.id
    this.action = this.$route.query.action
    this.initPageData()
  }

  private async initPageData () {
    this.loading = true
    const loading = this.$loading({ lock: true, text: 'Loading', spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)' })
    try {
      this.pageData = await getWorkOrderAnomaly({ id: this.orderId })
    } catch (error) {
    }
    this.loading = false
    loading.close()
  }

  /**
   * [description] 通知相关人员被点击的回调函数
   */
  private async onCallClick () {
    const { error }: any = await noticeAnomalyOrder({ id: this.orderId })
    if (!error) {
      this.$confirm('已在消息中心通知教研老师、产品中心老师', { showCancelButton: false, confirmButtonText: '知道了', type: 'info', confirmButtonClass: 'message-ok' })
    }
  }

  private async onCallOperations () {
    const { error }: any = await submitterAnomalyReport({ workOrderId: this.orderId })
    if (!error) {
      this.$message({ message: '操作成功', type: 'success' })
      TagsViewModule.delView(this.$route)
      this.$router.go(-1)
    }
  }

  /**
   * [description] 提交审批意见
   */
  private onDoClick () {
    //
  }

  /**
   * [description] 异常已解决点击
   */
  private async onDoneClick () {
    const { error }: any = await setWorkOrderStatus({ id: this.orderId, status: 1 })
    if (!error) {
      this.$message({ message: '操作成功', type: 'success' })
      TagsViewModule.delView(this.$route)
      this.$router.go(-1)
    }
  }

  /**
   * [description] 新增处理进度
   */
  private onAdd () {
    this.addDialogVisible = true
  }

  //
  private handleUploadSuccess (res: any) {
    this.addImgList.push(res.data)
  }

  // 新增处理进度
  private async onSubmitClick () {
    const param = {
      id: this.orderId,
      imageList: this.addImgList,
      progress: this.addProgress,
      progressStatus: Number(this.addResult)
    }
    const { error }: any = await addOrderRecord(param)
    if (!error) {
      this.addDialogVisible = false
      this.$message({ message: '操作成功', type: 'success' })
      TagsViewModule.delView(this.$route)
      this.$router.go(-1)
    }
  }

  // 添加审批意见
  private async onApproveClick () {
    const { error }: any = await setWorkOrderStatus({ comment: this.reason, id: this.orderId, status: 2 })
    if (!error) {
      this.$message({ message: '操作成功', type: 'success' })
      this.dialogVisible = false
      this.reason = ''
      TagsViewModule.delView(this.$route)
      this.$router.go(-1)
    }
  }
}
